export const mobileUnitTileFieldIdMap = {
	Mobile_number: 'number',
	Nickname: 'name',
	Email: 'email',
	Timesheet_status: 'Timesheet_status',
	Gps_status: 'Gps_status',
	Address: 'address',
}

export const GEOFENCES_TYPES = {
	SHARED_GEOFENCES: 'account',
	MOBILE_UNIT_GEOFENCES: 'device',
}

export const GEOFENCES_RENDER_TYPES = {
	CIRCLE: 'circle',
	POLYGON: 'polygon',
}

export const driverDriveTileFieldIdMap = {
	Start_date: 'start_date_timestamp',
	Stop_date: 'end_date_timestamp',
	Avg_speed: 'average_speed',
	Vehicle: 'external_id',
	Start_address: 'start_address',
	Stop_address: 'stop_address',
	Distance: 'distance_in_meters',
	Duration: 'duration',
	Drive_Id: 'driveId',
}

export const PAGE_SELECT_OPTIONS = [
	{
		name: 'Mobile units',
		position: '0',
		isDefault: true,
		type: 'page',
		page: {
			path: '/devices',
		},
		items: [],
	},
	{
		name: 'Forms',
		position: '1',
		isDefault: false,
		type: 'page',
		page: {
			path: '/forms',
		},
		items: [],
	},
	{
		name: 'Activity',
		position: '2',
		isDefault: false,
		type: 'page',
		page: {
			path: '/activity',
		},
		items: [],
	},
	{
		name: 'Scheduler',
		position: '3',
		isDefault: false,
		type: 'page',
		page: {
			path: '/scheduler',
		},
		items: [],
	},
	{
		name: 'Lookups',
		position: '4',
		isDefault: false,
		type: 'page',
		page: {
			path: '/lookups',
		},
		items: [],
	},
	{
		name: 'Views',
		position: '5',
		isDefault: false,
		type: 'page',
		page: {
			path: '/views',
		},
		items: [],
	},
	{
		name: 'Reports',
		position: '6',
		isDefault: false,
		type: 'page',
		page: {
			path: '/reports',
		},
		items: [],
	},
	{
		name: 'Geofences',
		position: '2',
		isDefault: false,
		type: 'page',
		page: {
			path: '/geofences',
		},
		items: [],
	},
]
